import { ThemeUICSSObject, focusOutline, spacing } from '@apia/theme';

const collapsiblePanel: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(2),
  '.collapsiblePanel__label': {
    display: 'flex',
    gap: spacing(2),
    p: '1px',
    alignItems: 'center',
    justifyContent: 'space-between',

    '.collapsiblePanel__label__button': {
      display: 'flex',
      gap: spacing(2),
      p: '1px',
      alignItems: 'center',
      '&:focus': focusOutline,
      color: 'palette.text.primary',
    },
  },
};

export default collapsiblePanel;
